import * as HandbookClient from 'api/clients/HandbookClient'
import { HandbookItem } from 'types'

export const HandbookService = {
  updateHandbookItem: async (itemId: number, values: Partial<HandbookItem>) => {
    const response = await HandbookClient.updateHandbookItem(itemId, values)
    return response
  },
}
